<template>
  <div class="footer">
    <div class="footer-wrap">
      <span class="copyright">Copyright © 石家庄慧教云创科技有限公司</span>
      <a href="https://beian.miit.gov.cn/" target="_blank" class="beian-link">冀ICP备2026017501号-1</a>
      <img src="https://res12.xesimg.com/public/img/jgwab.png" style="vertical-align: top">
      <a href="http://www.beian.gov.cn/" target="_blank" class="beian-link">冀公网安备13010402003498号</a>
    </div>
  </div>
</template>

<script>
  export default {
    name: "myFooter"
  }
</script>

<style scoped lang="scss">
  .footer {
    background: white;
    height: 100px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }
  .footer-wrap {
    display: flex;
    gap: 10px;
    align-items: center;
    font-size: 16px;
    color: #333;
  }
  .beian-link {
    color: #1A51AC;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/myFooter.vue